import {MNullable} from '../../Toolkit/Utils';
import {Crew, CrewData} from './CrewTypes';
import {Request} from './RequestTypes';
import {Invoice} from './InvoiceTypes';

export class JobAssignment {
    public id: number = 0;
    public requestId: string = '';
    public estimate: string = '';
    public assignedDate: MNullable<Date> = null;
    public tmType: number[] = [];
    public tmUsage: number = 0;
    public tmUsageNote: string = '';
    public additionalWork: boolean = false;
};

export class JobTask {
    public crews: Crew[] = [];
    public id: number = 0;
    public requestId: string = '';
    public assignedDate: MNullable<Date> = null;
    public tmType: number[] = [];
    public tmUsage: number = 0;
    public tmUsageNote: string = '';
    public additionalWork: boolean = false;
};

export class JobDay {
    public jobDate: MNullable<Date> = null;
    public tasks: JobTask[] = [];
}

export class JobData {
    public jobAssignment: JobAssignment = new JobAssignment();
    public crews: Crew[] | undefined;
    public request: Request | undefined;
}

export class DayView {
    public jobAssignment: JobAssignment = new JobAssignment();
    public request: Request | undefined;
    public crewData: CrewData[] | undefined;
    public invoice: Invoice[] | undefined;
}

export class MonthView {
    public jobAssignment: JobAssignment = new JobAssignment();
    public request: Request | undefined;
    public crewData: CrewData[] | undefined;
}

export class JobAssignmentReply {
    public jobAssignment: MNullable<JobAssignment> = null;
};

export class JobDataReply {
    public jobAssignment: MNullable<JobData> = null;
}

export class DayViewReply {
    public JobAssignment: MNullable<DayView> = null;
}

export class MonthViewReply {
    public JobAssignment: MNullable<MonthView> = null;
}

export class JobAssignmentMultiReply {
    public jobAssignments: JobAssignment[] = [];
};

export class JobAssignMultiReply {
    public jobAssignments: JobDay[] = [];
};

export class JobDataMultiReply {
    public jobAssignments: JobData[] = [];
};

export class DayViewMultiReply {
    public jobAssignments: DayView[] = [];
}

export class MonthViewMultiReply {
    public jobAssignments: MonthView[] = [];
}

export class JobAssignmentCount {
    public count: number = 0;
}